// Static route table for the area; pages load lazily (one chunk + its CSS).
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/modules/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const modulesRoutes: RouteObject[] = [
  {
    path: 'modules',
    handle: crumb('Modules'),
    children: [
      { index: true, lazy: page('ModuleListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('ModuleCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        children: [
          { index: true, lazy: page('ModuleEditPage') },
          { path: 'show', handle: crumb('Show'), lazy: page('ModuleShowPage') }
        ]
      }
    ]
  }
]
